import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import { interaction___playbutton, interaction___replay, interaction___pause, interaction___volumeOff, interaction___volume, interaction___volumeLow, banking_transfer_transferslip, interaction___fullscreenExit, interaction___fullscreenEnter } from '@lsg/icons';
import { format, addMilliseconds } from 'date-fns';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { texts } from '../../utils/Localization.js';
import { fComp, fRef } from '../../utils/React.js';
import '../ActionButton/ActionButtonPresentation.js';
import { ActionButtonWrapper } from '../ActionButton/ActionButtonWrapper.js';
import { IconPresentation } from '../Icon/IconPresentation.js';
import { IconLinkWrapper } from '../IconLink/IconLinkWrapper.js';
import '../IconLink/IconLinkPresentation.js';
import { IconLinkGroupWrapper } from '../IconLinkGroup/IconLinkGroupWrapper.js';
import '../IconLinkGroup/IconLinkGroupPresentation.js';
import { ParagraphPresentation } from '../Paragraph/ParagraphPresentation.js';
import '../Slider/SliderPresentation.js';
import { SliderWrapper } from '../Slider/SliderWrapper.js';
import { SpinnerPresentation } from '../Spinner/SpinnerPresentation.js';
import { getThemeClass } from '../Theme/ThemePresentation.js';
import { hostClass } from './Video.styles.js';

var defaultProps = {
  showControls: true,
  showProgressBar: true
}; // eslint-disable-next-line jsx-a11y/media-has-caption

var Video = fRef(function (_a) {
  var ref = _a.ref,
      props = __rest(_a, ["ref"]);

  return /*#__PURE__*/React.createElement("video", Object.assign({}, props, {
    ref: ref
  }));
}); // Formats the time to 00:00

var formatTime = function formatTime(timeIncoming) {
  var dateTime = addMilliseconds(new Date(2000, 1, 1), timeIncoming * 1000);
  return format(dateTime, timeIncoming > 3600 ? "hh:mm:ss" : "mm:ss");
};

var VideoPresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject2, _cleanupClassObject3, _cleanupClassObject4, _cleanupClassObject5, _cleanupClassObject8, _cleanupClassObject10, _cleanupClassObject11, _cleanupClassObject12, _cleanupClassObject13;

  var actionTopLeft = props.actionTopLeft,
      actionTopRight = props.actionTopRight,
      id = props.id,
      className = props.className,
      noMargin = props.noMargin,
      isStencilHost = props.isStencilHost,
      src = props.src,
      isMute = props.isMute,
      onIsMuteChange = props.onIsMuteChange,
      audioPanelOpen = props.audioPanelOpen,
      onAudioPanelSetOpen = props.onAudioPanelSetOpen,
      audioVolume = props.audioVolume,
      onAudioVolumeChange = props.onAudioVolumeChange,
      controlsOpen = props.controlsOpen,
      onControlsSetOpen = props.onControlsSetOpen,
      isPosterVisible = props.isPosterVisible,
      loop = props.loop,
      poster = props.poster,
      playbackState = props.playbackState,
      onPlaybackStateChange = props.onPlaybackStateChange,
      onFullScreen = props.onFullScreen,
      showControls = props.showControls,
      showProgressBar = props.showProgressBar,
      textVideoAlt = props.textVideoAlt,
      time = props.time,
      videoProgress = props.videoProgress,
      onVideoProgressChange = props.onVideoProgressChange,
      onVideoCanPlay = props.onVideoCanPlay,
      videoTitle = props.videoTitle,
      videoRef = props.videoRef,
      videoContainerRef = props.videoContainerRef,
      videoAutoplayMarkerId = props.videoAutoplayMarkerId,
      fullscreenActive = props.fullscreenActive,
      captionSrc = props.captionSrc,
      captionLang = props.captionLang;
  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, getThemeClass("dark"), true), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-overlay"), true), _defineProperty(_cleanupClassObject2, getThemeClass("contrast"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-unavailable"), playbackState === "unavailable"), _cleanupClassObject2)),
    onMouseMove: onControlsSetOpen,
    ref: videoContainerRef
  }, /*#__PURE__*/React.createElement(Video, {
    className: cleanupClassObject((_cleanupClassObject3 = {}, _defineProperty(_cleanupClassObject3, "".concat(hostClass, "-source"), true), _defineProperty(_cleanupClassObject3, "".concat(hostClass, "-source-fullscreen"), fullscreenActive), _cleanupClassObject3)),
    id: id,
    ref: videoRef,
    src: src,
    onClick: function onClick() {
      return onPlaybackStateChange(playbackState === "paused" ? "running" : "paused");
    },
    onCanPlay: onVideoCanPlay,
    title: videoTitle,
    loop: loop,
    onError: function onError() {
      return onPlaybackStateChange("unavailable");
    }
  }, /*#__PURE__*/React.createElement("div", null), texts.lsg.component.Video.notSupported, /*#__PURE__*/React.createElement("br", null), textVideoAlt, captionSrc && /*#__PURE__*/React.createElement("track", {
    default: true,
    kind: "captions",
    src: captionSrc,
    srcLang: captionLang
  })), poster && isPosterVisible && /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-poster"),
    style: {
      backgroundImage: "url('".concat(poster, "')")
    }
  }), /*#__PURE__*/React.createElement("div", {
    id: videoAutoplayMarkerId,
    className: cleanupClassObject((_cleanupClassObject4 = {}, _defineProperty(_cleanupClassObject4, "".concat(hostClass, "-grey-overlay"), true), _defineProperty(_cleanupClassObject4, "".concat(hostClass, "-grey-overlay__hidden"), playbackState === "running"), _cleanupClassObject4)),
    onClick: function onClick() {
      return onPlaybackStateChange("paused");
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject5 = {}, _defineProperty(_cleanupClassObject5, "".concat(hostClass, "-actions"), true), _defineProperty(_cleanupClassObject5, "".concat(hostClass, "__hidden"), !controlsOpen), _defineProperty(_cleanupClassObject5, "".concat(hostClass, "-show-controls"), showControls), _cleanupClassObject5))
  }, /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
    className: cleanupClassObject(_defineProperty({}, "".concat(hostClass, "-actions-left"), true)),
    direction: "collapse-xs"
  }, actionTopLeft), /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
    className: cleanupClassObject(_defineProperty({}, "".concat(hostClass, "-actions-right"), true)),
    direction: "collapse-xs"
  }, actionTopRight)), /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject8 = {}, _defineProperty(_cleanupClassObject8, "".concat(hostClass, "-center"), true), _defineProperty(_cleanupClassObject8, "".concat(hostClass, "__hidden"), playbackState === "running" || !showControls), _defineProperty(_cleanupClassObject8, "".concat(hostClass, "-controls-hidden"), !controlsOpen), _cleanupClassObject8)),
    onClick: function onClick() {
      return playbackState === "paused" || playbackState === "done" ? onPlaybackStateChange("running") : onPlaybackStateChange("paused");
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject(_defineProperty({}, "".concat(hostClass, "-center-interaction-buttons"), true))
  }, (playbackState === "paused" || playbackState === "running") && /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-center-play-button")
  }, /*#__PURE__*/React.createElement(IconPresentation, {
    noMargin: true,
    icon: interaction___playbutton,
    color: "anthracite",
    variant: "solid",
    title: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-center-loading-and-error")
  }, (playbackState === "loading" || playbackState === "unavailable") && /*#__PURE__*/React.createElement(SpinnerPresentation, null), playbackState === "unavailable" && /*#__PURE__*/React.createElement(ParagraphPresentation, {
    size: "info-text"
  }, texts.lsg.component.Video.notSupported)), playbackState === "done" && /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-center-replay-button")
  }, /*#__PURE__*/React.createElement(ActionButtonWrapper, {
    noMargin: true,
    icon: interaction___replay,
    look: "secondary",
    iconVariant: "solid",
    // color="white" TODO
    onClick: function onClick() {
      return onPlaybackStateChange("running");
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-center-text")
  }, texts.lsg.component.Video.replay)))), /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject10 = {}, _defineProperty(_cleanupClassObject10, "".concat(hostClass, "-footer"), true), _defineProperty(_cleanupClassObject10, "".concat(hostClass, "__hidden"), !controlsOpen || !showControls), _cleanupClassObject10))
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject11 = {}, _defineProperty(_cleanupClassObject11, "".concat(hostClass, "-progress"), true), _defineProperty(_cleanupClassObject11, "".concat(hostClass, "__hidden"), !controlsOpen), _defineProperty(_cleanupClassObject11, "".concat(hostClass, "-show-progress-bar"), showProgressBar), _cleanupClassObject11))
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-slider")
  }, /*#__PURE__*/React.createElement(SliderWrapper, {
    noMargin: true,
    minValue: 0,
    value: videoProgress,
    maxValue: 100,
    onChange: onVideoProgressChange,
    // onDragStart={onVideoSliderDragStart}
    showThumb: controlsOpen
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-time")
  }, time && formatTime(time) || "Live")), /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject12 = {}, _defineProperty(_cleanupClassObject12, "".concat(hostClass, "-controls"), true), _defineProperty(_cleanupClassObject12, "".concat(hostClass, "-show-controls"), showControls), _cleanupClassObject12))
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-controls-left")
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject13 = {}, _defineProperty(_cleanupClassObject13, "".concat(hostClass, "-audio-control"), true), _defineProperty(_cleanupClassObject13, "".concat(hostClass, "__hidden"), audioPanelOpen === false), _cleanupClassObject13)),
    onMouseMove: onAudioPanelSetOpen
  }, /*#__PURE__*/React.createElement("input", {
    className: cleanupClassObject(_defineProperty({}, "".concat(hostClass, "-audio-control-input"), true)),
    type: "range",
    min: "0",
    max: "100",
    value: isMute ? 0 : audioVolume,
    onChange: function onChange(e) {
      return onAudioVolumeChange(parseInt(e.target.value, 10));
    }
  })), /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
    noMargin: true,
    className: cleanupClassObject(_defineProperty({}, "".concat(hostClass, "iconlink__no-animation"), true)),
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(IconLinkWrapper, {
    iconColor: "white",
    icon: playbackState === "paused" && interaction___playbutton || interaction___pause,
    iconVariant: "solid",
    look: "no-text",
    onClick: function onClick() {
      return onPlaybackStateChange(playbackState === "paused" ? "running" : "paused");
    },
    hasTabIndex: false
  }, playbackState === "paused" && texts.lsg.component.Video.play || texts.lsg.component.Video.pause), /*#__PURE__*/React.createElement(IconLinkWrapper, {
    className: cleanupClassObject(_defineProperty({}, "".concat(hostClass, "iconlink_audio"), true)),
    look: "no-text",
    iconColor: "white",
    icon: (isMute || audioVolume === 0) && interaction___volumeOff || audioVolume > 50 && interaction___volume || interaction___volumeLow,
    hasTabIndex: false,
    onClick: function onClick() {
      return onIsMuteChange(!isMute);
    },
    onMouseHoverChange: function onMouseHoverChange() {
      return onAudioPanelSetOpen();
    }
  }, isMute && texts.lsg.component.Video.unMute || texts.lsg.component.Video.mute), captionSrc && /*#__PURE__*/React.createElement(IconLinkWrapper, {
    look: "no-text",
    iconColor: "white",
    icon: banking_transfer_transferslip,
    hasTabIndex: false
  }, texts.lsg.component.Video.captionOff || texts.lsg.component.Video.captionOn)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-controls-title")
  }, videoTitle)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-controls-right")
  }, /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
    noMargin: true,
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(IconLinkWrapper, {
    icon: fullscreenActive ? interaction___fullscreenExit : interaction___fullscreenEnter,
    onClick: onFullScreen,
    iconColor: "white",
    hasTabIndex: false,
    look: "no-text"
  }, texts.lsg.component.Video.fullScreen)))))));
}, defaultProps);

export { VideoPresentation, defaultProps };
